<script setup lang="ts">
import { cn } from '@/lib/utils';
import { TabsList, type TabsListProps } from 'reka-ui';
import { computed, type HTMLAttributes } from 'vue';

const props = defineProps<TabsListProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;
  return delegated;
});
</script>

<template>
  <TabsList
    v-bind="delegatedProps"
    :class="
      cn(
        'tw-inline-flex tw-h-9 tw-items-center tw-justify-center tw-rounded-lg tw-bg-neutral-100 tw-p-1 tw-text-neutral-500 dark:tw-bg-neutral-800 dark:tw-text-neutral-400',
        props.class
      )
    "
  >
    <slot />
  </TabsList>
</template>
